import { Power } from "lucide-react";
import React from "react";
import DramaticConfirmationModal from "../DramaticConfirmationModal";

interface IBServiceControlModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  mode: "turn-on" | "turn-off";
  loading: boolean;
  advisorAlias?: string;
}

const IBServiceControlModal: React.FC<IBServiceControlModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  mode,
  loading,
  advisorAlias,
}) => {
  const isTurnOn = mode === "turn-on";
  const serviceName = advisorAlias ? `IB Service (${advisorAlias})` : "IB Service";

  const turnOnActions = [
    { text: "Initialize OAuth authentication" },
    { text: "Start the tickle scheduler" },
    { text: "Enable brokerage session connectivity" },
    { text: "Begin processing trading operations" },
  ];

  const turnOffActions = [
    { text: "Stop all running schedulers" },
    { text: "Terminate the brokerage session" },
    { text: "Disable all trading operations" },
    { text: "Log out from IBKR gateway" },
  ];

  return (
    <DramaticConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      title={isTurnOn ? `Power On ${serviceName}` : `Power Off ${serviceName}`}
      subtitle="Interactive Brokers Integration Service"
      loadingTitle={isTurnOn ? "Powering On..." : "Shutting Down..."}
      loadingSubtitle={
        isTurnOn
          ? "Initializing systems and establishing connections"
          : "Gracefully terminating connections and schedulers"
      }
      actions={isTurnOn ? turnOnActions : turnOffActions}
      mode={isTurnOn ? "positive" : "destructive"}
      icon={Power}
      confirmText={isTurnOn ? "Power On" : "Power Off"}
      cancelText="Cancel"
      showParticles={true}
    />
  );
};

export default IBServiceControlModal;
